<template>
<div data-component="Loader.vue" class="[ loader ] flex items-center justify-center">
	<template v-if="Type === 'ring'">
		<div class="ring-loader" :class="loaderSize">
			<div/>
			<div/>
			<div/>
			<div/>
		</div>
	</template>
	<template v-else>
		<div class="mx-auto my-6 lds-ellipsis" :class="OptionalStyling">
			<div/>
			<div/>
			<div/>
			<div/>
		</div>
	</template>
</div>
</template>

<script lang="ts">
// @vuese
// Komponent odpowiedzialny za wyświetlenie animacji ładowania.
// @group Base Components
export default {
	name: 'Loader',
	props: {
		Type: { default: 'ellipsis', type: String },
		OptionalStyling: { default: '', type: String },
		// narazzie tylko dla loadera typu ring
		size: {
			type: String,
			default: 'medium',
			validator: (value) => ['small', 'medium', 'large'].includes(value),
		},
	},
	computed: {
		loaderSize() {
			return `ring-loader--${this.size}`;
		},
	},
};
</script>

<style lang="scss">
.ring-loader {
	position: relative;
	display: flex;
	align-items: center;

	div {
		position: absolute;
		display: block;
		box-sizing: border-box;
		border-color: var(--accent) transparent transparent transparent;
		margin: auto;
		animation: ring-loader 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
		border-radius: 50%;
	}

	&--small {
		width: 40px;
		height: 40px;

		div {
			width: 32px;
			height: 32px;
			border-width: 4px;
		}
	}

	&--medium {
		width: 80px;
		height: 80px;

		div {
			width: 64px;
			height: 64px;
			border-width: 8px;
		}
	}

	&--large {
		width: 120px;
		height: 120px;

		div {
			width: 96px;
			height: 96px;
			border-width: 12px;
		}
	}
}

@keyframes ring-loader {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}

.lds-ellipsis {
	position: relative;
	display: inline-block;
	width: 64px;
	height: 64px;

	div {
		position: absolute;
		top: 27px;
		width: 11px;
		height: 11px;
		animation-timing-function: cubic-bezier(0, 1, 1, 0);
		background: var(--accent);
		border-radius: 50%;

		&:nth-child(1) {
			left: 6px;
			animation: lds-ellipsis1 0.6s infinite;
		}

		&:nth-child(2) {
			left: 6px;
			animation: lds-ellipsis2 0.6s infinite;
		}

		&:nth-child(3) {
			left: 26px;
			animation: lds-ellipsis2 0.6s infinite;
		}

		&:nth-child(4) {
			left: 45px;
			animation: lds-ellipsis3 0.6s infinite;
		}
	}
}

@keyframes lds-ellipsis1 {
	0% {
		transform: scale(0);
	}

	100% {
		transform: scale(1);
	}
}

@keyframes lds-ellipsis3 {
	0% {
		transform: scale(1);
	}

	100% {
		transform: scale(0);
	}
}

@keyframes lds-ellipsis2 {
	0% {
		transform: translate(0, 0);
	}

	100% {
		transform: translate(19px, 0);
	}
}

@keyframes a {
	from {
		opacity: 0;
	}

	to {
		opacity: 1;
	}
}
</style>
